import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getSeamHttpClient } from "./use-seam-client"
import { ConnectWebviewsDeleteParameters } from "@seamapi/http"

export const useDeleteConnectWebview = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({
      workspace_id,
      ...params
    }: ConnectWebviewsDeleteParameters & { workspace_id: string }) => {
      const client = getSeamHttpClient(workspace_id)
      const result = await client.connectWebviews.delete(params)
      return result
    },
    onSuccess: (_, params) => {
      qc.invalidateQueries({
        queryKey: ["connect_webviews", params.workspace_id],
      })
    },
  })
}
